<template>
  <span>
    <div class="background-wallpaper" style="background-image: url(https://res.cloudinary.com/hyimvofxm/image/upload/v1636737932/9_68caa27a4e.png);"></div>
    <section class="spaced">
      <div class="container content flex spaced">
        <div class="column c12 text-center spaced">
          <h1 class="spaced">ARTISTS</h1>
        </div>
        <div class="column c6 push-center">
          <p class="text-center">
            A community from all over the globe, sharing a vision. Read their stories, access their art or book them for your event.
          </p>
        </div>
      </div>
    </section>
    <section class="spaced">
      <div class="container content flex">
        <div class="text-center filter-container">
          <div class="filter-button" @click="filter('all')">ALL</div>
          <div class="filter-button" @click="filter('Producer')">PRODUCER</div>
          <div class="filter-button" @click="filter('Disc Jockey')">DISC JOCKEY</div>
          <div class="filter-button" @click="filter('Performer')">PERFORMER</div>
          <div class="filter-button" @click="filter('Visual Artist')">VISUAL ARTIST</div>
        </div>
      </div>
      <div class="container content">
        <div class="profiles column c12 flex">
          <router-link class="profile column c4 card" v-if="selectedCat === artist.artistcategories[0]['type']  || selectedCat === 'all'"
               v-for="artist in artists" :key="artist.id" :class="'artist-profile ' + artist.artistcategories[0]['type'] "
               :to="{ name: 'artist', params: { id : artist.slug }}"
               >
            <div class="card-inner circle">
              <div class="shade">
                <div class="artwork"
                      v-if="artist.profile !== null" :style="'background-image:url(' + artist.profile.url + ')'"
                      ></div>
                <div class="card-overlay-artist text-left push-middle">
                  <div class="card-content">
                    <h2>{{ artist.name }} </h2>
                    <h3>{{ artist.artistcategories[0]['type'] }} <br> {{ artist.country }}</h3>
                  </div>
                </div>
                <!-- <div class="card-overlay-player text-left push-middle">
                  <div class="card-content">
                    <h2>{{ artist.name }}</h2>
                    <h3>{{ artist.artistcategories[0]['type'] }} <br> {{ artist.country }}</h3>
                  </div>
                </div> -->
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
  </span>
</template>

<script>
import axios from 'axios'
export default {
  title: 'Patronus Records - Artists',
  name: 'music',
  data () {
    return {
      artists: [],
      artistcategories: [],
      selectedCat: 'all'
    }
  },
  created () {
    axios
      .get('https://admin.patronusrecords.com/artists')
      .then((response) => {
        response.data.sort(function (a, b) {
          var nameA = a.name.toLowerCase()
          var nameB = b.name.toLowerCase()
          if (nameA < nameB) { return -1 }
          if (nameA > nameB) { return 1 }
          return 0
        })
        this.artists = response.data
      })
    axios
      .get('https://admin.patronusrecords.com/Artistcategories')
      .then((response) => {
        this.category = response.data
      })
  },
  methods: {
    filter (selection) {
      this.selectedCat = selection
    }
  }
}
</script>
<style scoped>
.artwork {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-size:cover;
    background-position:center center;
}

</style>



// WEBPACK FOOTER //
// src/pages/artists.vue